import { render, staticRenderFns } from "./PaymentGateways.vue?vue&type=template&id=6ec71d7e&scoped=true"
import script from "./PaymentGateways.vue?vue&type=script&lang=js"
export * from "./PaymentGateways.vue?vue&type=script&lang=js"
import style0 from "./PaymentGateways.vue?vue&type=style&index=0&id=6ec71d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec71d7e",
  null
  
)

export default component.exports